<template>
  <div v-show="show" class="main-content-container container-fluid px-4">
    <!-- page header -->
    <div class="d-flex page-header row no-gutters py-4">
      <div class="col-12 col-md-8 text-center text-sm-left mb-sm-0 mb-3">
        <span class="text-uppercase page-subtitle">Mes demandes</span>
        <h3 class="page-title">{{ $t("dailyReport.title") }}</h3>
      </div>
      <div></div>
      <div v-if="dateOfReport" class="col-12 col-md-4 pt-md-3">
        <div class="back-next-btn float-left float-sm-right">
          <button class="back-btn-submit" @click="back()">
            <i class="fa fa-arrow-left" aria-hidden="true"></i>
            {{ $t("global.return") }}
          </button>

          <button
            class="next-btn-submit"
            style="width: 150px"
            @click="goNext()"
          >
            {{ this.create == 1 ? "Créer" : "Enregistrer" }}
            <i class="fa fa-arrow-right" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      <div
        v-if="!reportCard.tasks"
        class="no-work-div justify-content-center justify-content-md-end mt-1"
      >
        <button class="no-work-btn" @click="noReport()">
          {{ $t("dailyReport.noWork") }}
          <i class="fa fa-arrow-right" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <daily-report v-if="!dateOfReport"></daily-report>
    <!-- card body -->
    <div v-if="dateOfReport" class="row">
      <div class="col-sm-7 col-md-12 col-lg-12 col-xl-7">
        <div class="row">
          <!-- date card -->
          <div class="col-md-6 col-xl-6">
            <div
              style="height: 150px"
              class="card card-custom mb-2 mb-md-4 mt-2 mt-md-3"
            >
              <div class="card-body">
                <div class="d-flex flex-row align-items-center">
                  <div class="w-40 p-3 calander-div">
                    <img src="@/assets/images/calander.svg" />
                  </div>
                  <div
                    class="w-60 font-weight-bold pt-5 pl-5 pl-sm-3 pl-lg-5 pl-xl-3 text-center date-time-div mb-md-4"
                  >
                    <p>{{ dateOfReport }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- total hours card -->
          <div class="col-md-6 col-xl-6">
            <div
              class="card card-custom mb-2 mb-md-4 mt-3"
              style="height: 150px"
            >
              <div class="card-body">
                <div class="d-flex flex-row align-items-center">
                  <div class="w-40 p-3 clock-div mt-3">
                    <img src="@/assets/images/clock-regular.svg" />
                  </div>
                  <div
                    class="w-60 font-weight-bold pt-5 pl-5 pl-sm-3 pl-lg-5 pl-xl-3 text-center date-time-div ml-md-4"
                  >
                    <p class="text-center">{{ $t("dailyReport.totalTime") }}</p>
                    <span class="text-center"> {{ reportCard.totalTime }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-sm-12 col-md-12 col-lg-12 col-xl-12"
            v-for="(report, index) in computedNewTask"
            :key="index"
          >
            <div class="card card-custom mb-4 mt-3">
              <div class="card-body count-task-body">
                <div
                  class="d-flex align-items-center justify-content-between task-info"
                >
                  <div class="w-100 pt-4 pb-4 bg-white rounded-right">
                    <div class="d-flex">
                      <div class="form-group padding-left-right w-100">
                        <label for="task">{{ $t("dailyReport.task") }}</label>
                        <input
                          type="text"
                          class="task-input form-control"
                          v-model="report.title"
                          autocomplete="off"
                          :placeholder="$t('dailyReport.task')"
                        />
                        <errors :errors="errors" :field="`title${index}`" />
                      </div>
                      <div class="ml-auto" @click="removeTask(index)">
                        <div class="clear">
                          <span class="close-icon"> </span>
                        </div>
                      </div>
                    </div>
                    <div class="space row time-selector">
                      <div class="col-md-4 pb-lg-0 pb-2 time-only-mobile">
                        <div class="pb-1 label">
                          {{ $t("dailyReport.totalTime") }}
                        </div>
                        <div
                          v-if="
                            report.duration.hour >= 0 &&
                            report.duration.mint >= 0
                          "
                          class="border rounded p-2 text-center total-hour"
                        >
                          {{ formatedDuration(report.duration.hour) }}h

                          {{ formatedDuration(report.duration.mint) }}min
                        </div>
                        <div
                          v-else
                          class="border rounded p-2 text-center total-hour"
                        >
                          0h 0min
                        </div>
                        <div>
                          <errors
                            :errors="errors"
                            :field="`duration${index}`"
                          />
                        </div>
                      </div>
                      <div class="time-picker">
                        <time-picker
                          :original="report"
                          label="Heure de début"
                          :model="startTime"
                          :onChange="onChangeStart"
                          type="start"
                        />
                        <errors :errors="errors" :field="`startHour${index}`" />
                      </div>
                      <div class="time-picker">
                        <time-picker
                          :original="report"
                          label="Heure de fin"
                          :model="endTime"
                          :onChange="onChangeEnd"
                          type="end"
                        />
                        <errors :errors="errors" :field="`endHour${index}`" />
                      </div>
                      <div
                        class="report-field ml-md-4 pb-lg-0 pb-2 time-only-desktop"
                      >
                        <div class="pb-1 label">
                          {{ $t("dailyReport.totalTime") }}
                        </div>
                        <div
                          v-if="
                            report.duration.hour >= 0 &&
                            report.duration.mint >= 0
                          "
                          class="border rounded p-2 text-center total-hour"
                        >
                          {{ report.duration.hour }}h
                          {{ report.duration.mint }}min
                        </div>
                        <div
                          v-else
                          class="border rounded p-2 text-center total-hour"
                        >
                          0h 0min
                        </div>
                        <div>
                          <errors
                            :errors="errors"
                            :field="`duration${index}`"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="card card-custom" @click="AddNewTask()">
              <div class="card-body">
                <div class="overlay-add-new">
                  <div class="add-new-task">
                    <i class="fas fa-plus pr-3"></i>
                    <span>{{ $t("dailyReport.addNewTask") }}</span>
                  </div>
                  <div class="add-new-dots-border">
                    <img src="@/assets/images/dots-image.png" alt="Dots" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Errors from "../../components/error/errors.vue";
import dailyReport from "../../components/shared/dailyReport.vue";
import ErrorsHelper from "../../helper/ErrorsHelper";
import moment from "moment-timezone";
import TimePicker from "./time-picker";

var from = null;
export default {
  props: ["create"],
  data() {
    return {
      dialog: false,
      reportCard: {
        dateOfReport: "",
        dateOfSubmission: new Date(),
        totalTime: "0h 0min",
        tasks: [],
      },
      startTime: "",
      endTime: "",
      requiredFields: ["title", "startHour", "endHour", "duration"],
      errors: {},
      dateOfReport: "",
      show: false,
      task: "",
    };
  },
  components: {
    Errors,
    dailyReport,
    TimePicker,
  },
  created() {
    if (from.path === "/") {
      this.$router.back(-1);
    } else {
      this.show = true;
    }
  },

  mounted() {
    if (from.path === "/reportCard") {
      this.reportCard = this.$store.state.dailyReport.reportCardOldState;
      this.dateOfReport = moment(this.reportCard.dateOfReport).format(
        "dddd Do MMMM YYYY"
      );
    } else {
      if (this.dateOfReport === "") {
        if (this.create == 1) {
          this.dateOfReport = this.$store.state.dailyReport.dateOfReport;
          this.reportCard = {
            dateOfReport: this.dateOfReport,
            dateOfSubmission: new Date(this.dateOfReport),
            totalTime: "0h 0min",
            tasks: [],
          };
          this.addTask();
          this.dateOfReport = moment(this.dateOfReport).format(
            "dddd Do MMMM YYYY"
          );
        } else {
          this.dateOfReport = this.$store.state.dailyReport.dateOfReport;
          this.dateOfReport = moment(this.dateOfReport).format(
            "dddd Do MMMM YYYY"
          );
          this.reportCard = this.$store.state.dailyReport.reportCard;
        }
      }
    }
  },
  beforeRouteEnter(to, fromRoute, next) {
    from = fromRoute;
    next((vm) => {
      vm.prevRoute = from;
      return vm;
    });
  },

  computed: {
    computedNewTask() {
      return this.reportCard.tasks;
    },
  },
  methods: {
    calculateTotalTime() {
      let totalTime = { hour: 0, mint: 0 };
      this.reportCard.tasks.forEach((task) => {
        totalTime.hour += Number(task.duration.hour);
        totalTime.mint += Number(task.duration.mint);
      });

      totalTime.hour += Math.floor(totalTime.mint / 60);
      totalTime.mint = totalTime.mint % 60;

      this.reportCard.totalTime = `${
        totalTime.hour < 10 ? `0${totalTime.hour}` : totalTime.hour
      }h ${totalTime.mint < 10 ? `0${totalTime.mint}` : totalTime.mint}m`;
    },

    formatedDuration(time) {
      return time < 10 ? `0${time}` : time;
    },
    msToHMS(ms) {
      // 1- Convert to seconds:
      let seconds = ms / 1000;

      let hours = parseInt(seconds / 3600);
      seconds = seconds % 3600;

      let minutes = parseInt(seconds / 60);

      seconds = seconds % 60;
      return {
        hours,
        minutes,
      };
    },
    timeDifference(t1, t2) {
      const startDate = new Date(Date.now());
      const endDate = new Date(Date.now());
      startDate.setHours(t1.hour);
      startDate.setMinutes(t1.mint);
      endDate.setHours(t2.hour);
      endDate.setMinutes(t2.mint);

      const diff = endDate.getTime() - startDate.getTime();

      return this.msToHMS(diff);
    },
    onChangeStart(task, val) {
      const splitArr = val.split(":");
      task.startHour.hour = splitArr[0];
      task.startHour.mint = splitArr[1];
      if (Number(task.endHour.hour) >= 0) {
        const diffTime = this.timeDifference(task.startHour, task.endHour);

        task.duration = {
          hour: `${
            diffTime.hours < 10 ? `0${diffTime.hours}` : diffTime.hours
          }`,
          mint: `${
            diffTime.minutes < 10 ? `0${diffTime.minutes}` : diffTime.minutes
          }`,
        };
        const { tasks } = this.reportCard;
        let totalTime = { hour: 0, mint: 0 };

        tasks.forEach((item) => {
          totalTime.hour += Number(item.duration.hour);
          totalTime.mint += Number(item.duration.mint);
        });

        totalTime.hour += Math.floor(totalTime.mint / 60);
        totalTime.mint = totalTime.mint % 60;

        this.reportCard.totalTime = `${
          totalTime.hour < 10 ? `0${totalTime.hour}` : totalTime.hour
        }h ${totalTime.mint < 10 ? `0${totalTime.mint}` : totalTime.mint}m`;
      }

      this.calculateTotalTime();
    },

    onChangeEnd(task, val) {
      const splitArr = val.split(":");
      task.endHour.hour = splitArr[0];
      task.endHour.mint = splitArr[1];
      if (task.startHour.hour < 0) {
        return;
      }
      const diffTime = this.timeDifference(task.startHour, task.endHour);

      task.duration = {
        hour: `${diffTime.hours < 10 ? `0${diffTime.hours}` : diffTime.hours}`,
        mint: `${
          diffTime.minutes < 10 ? `0${diffTime.minutes}` : diffTime.minutes
        }`,
      };
      const { tasks } = this.reportCard;
      let totalTime = { hour: 0, mint: 0 };
      tasks.forEach((item) => {
        totalTime.hour += Number(item.duration.hour);
        totalTime.mint += Number(item.duration.mint);
      });

      totalTime.hour += Math.floor(totalTime.mint / 60);
      totalTime.mint = totalTime.mint % 60;

      this.reportCard.totalTime = `${
        totalTime.hour < 10 ? `0${totalTime.hour}` : totalTime.hour
      }h ${totalTime.mint < 10 ? `0${totalTime.mint}` : totalTime.mint}m`;

      this.calculateTotalTime();
    },
    back() {
      this.$router.back(-1);
    },
    AddNewTask() {
      if (this.reportCard.tasks.length > 0) {
        this.validateReportCard() ? this.addTask() : "";
      } else {
        this.addTask();
      }
    },

    addTask(val) {
      this.reportCard.tasks.push({
        startHour: {
          hour: -1,
          mint: -1,
        },
        endHour: {
          hour: -1,
          mint: -1,
        },
        duration: {
          hour: -1,
          mint: -1,
        },
      });
    },

    noReport() {
      this.requiredFields = [];
      this.reportCard.comment = "Je n’ai pas besoin de remplir ce jour.";
      this.reportCard.tasks[0].title = "";
      this.reportCard.tasks[0].startHour.hour = 0;
      this.reportCard.tasks[0].startHour.mint = 0;
      this.reportCard.tasks[0].endHour.hour = 0;
      this.reportCard.tasks[0].endHour.mint = 0;
      this.reportCard.tasks[0].duration.hour = 0;
      this.reportCard.tasks[0].duration.mint = 0;
      this.goNext();
    },

    removeTask(index) {
      const duration = `${this.reportCard.tasks[index].duration.hour}h ${this.reportCard.tasks[index].duration.mint}min`;
      this.reportCard.tasks.splice(index, 1);
      this.reportCard.totalTime = this.getTotalTime(duration, 0); // subtraction of removed one
    },

    getDuration(startHour, endHour, index) {
      const startHourInMinutes = startHour.hour * 60 + startHour.mint * 1;
      const endtHourInMinutes = endHour.hour * 60 + endHour.mint * 1;
      if (endtHourInMinutes - startHourInMinutes > 0) {
        const differenceInHours = parseInt(
          (endtHourInMinutes - startHourInMinutes) / 60,
          10
        );
        const differenceInMinutes =
          (endtHourInMinutes - startHourInMinutes) % 60;
        const totalDifference = `${differenceInHours}h ${differenceInMinutes}min`;
        this.reportCard.tasks[index].duration.hour = differenceInHours;
        this.reportCard.tasks[index].duration.mint = differenceInMinutes;
        this.reportCard.totalTime = this.getTotalTime(totalDifference);
      } else {
        this.reportCard.tasks[index].duration.hour = -1;
        this.reportCard.tasks[index].duration.mint = -1;
      }
      this.validateReportCard();
    },

    getTotalTime(duration) {
      this.reportCard.totalTime = "0h 0min";
      let minutes = 0;
      if (duration) {
        let totalTime = this.reportCard.totalTime;
        for (let i = 0; i < this.reportCard.tasks.length; i++) {
          const totalHnM = totalTime.split(" ");
          const totalH = totalHnM[0].substring(0, totalHnM[0].length - 1);
          const totalM = totalHnM[1].substring(0, totalHnM[1].length - 3);
          const durationH = this.reportCard.tasks[i].duration.hour;
          const durationM = this.reportCard.tasks[i].duration.mint;
          minutes =
            minutes + totalH * 60 + durationH * 60 + totalM * 1 + durationM * 1;
        }
        totalTime = `${parseInt(minutes / 60, 10)}h ${minutes % 60}min`;
        return totalTime;
      }
    },

    getValue(val) {
      return val < 0 ? 0 : val;
    },

    validateReportCard() {
      let i = 0;
      const valid = [];
      this.errors = {};
      this.reportCard.tasks.forEach((task) => {
        task.id = i;
        valid[i] = ErrorsHelper.checkErrors(
          this.requiredFields,
          task,
          this.errors
        );
        i++;
      });
      return !valid.includes(false);
    },

    goNext() {
      if (this.validateReportCard()) {
        this.$store.dispatch("setReportCardOldState", this.reportCard);
        this.$store.dispatch("setReportCard", this.reportCard);
        this.$router.push("/reportCard");
      }
    },
  },
};
</script>
<style lang="scss">
.time-picker {
  text-align: center;
  margin: 10px;
  margin-top: 23px;
}
.space {
  display: flex;
  justify-content: center;
}
.back-next-btn {
  @media (max-width: 767px) {
    width: 100%;
    text-align: center;
  }
  .back-btn-submit {
    padding: 6px 20px;
    border: 1px solid #4f78e2;
    background-color: #fff;
    color: #4f78e2;
    border-radius: 4px;
    font-family: "SF-Pro-Text";
    font-weight: 500;
    outline: none;
  }
  .next-btn-submit {
    padding: 6px 20px;
    background-color: #4f78e2;
    border: 1px solid #4f78e2;
    color: #fff;
    border-radius: 4px;
    font-family: "SF-Pro-Text";
    font-weight: 500;
    outline: none;
  }
}
.no-work-div {
  display: flex;
  width: 100%;
}
.no-work-btn {
  border: solid 1px #ffb400;
  background-color: white;
  color: #ffb400;
  border-radius: 4px;
  width: 150px;
  font-family: "SF-Pro-Text";
  font-weight: 500;
  padding: 6px 10px;
}
.card {
  box-shadow: 0 7px 40px 0 rgba(90, 97, 105, 0.1) !important;
}
.padding-left-right,
.time-selector {
  padding: 0 30px;
}
@media (max-width: 767px) {
  .padding-left-right {
    padding: 0 0 0 25px;
  }
}
.card-body {
  padding: 0.65rem !important;
}
.calander-div {
  border-radius: 18px;
  box-shadow: 0 7px 40px 0 rgba(90, 97, 105, 0.1);
  background-color: #f6a91d;
  img {
    width: 50px;
    height: 50px;
    @media screen and (min-width: 320px) and (max-width: 1300px) {
      width: 30px;
      height: 30px;
    }
  }
}
.clock-div {
  border-radius: 18px;
  box-shadow: 0 7px 40px 0 rgba(90, 97, 105, 0.1);
  background-color: #06aeea;
  img {
    width: 50px;
    height: 50px;
    @media screen and (min-width: 320px) and (max-width: 1300px) {
      width: 30px;
      height: 30px;
    }
  }
}
.date-time-div {
  font-size: 18px;
  p {
    color: #212529;
    padding: 0px !important;
    margin-bottom: 3px;
    font-family: "SF-Pro-Text";
    font-weight: 500;
  }
}
.d-comment {
  object-fit: contain;
  font-family: "SF-Pro-Text";
  font-size: 30px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: left;
  font-family: "SF-Pro-Text";
  @media screen and (min-width: 1200px) and (max-width: 1600px) {
    font-size: 20px;
  }
  @media screen and (min-width: 768px) and (max-width: 1024px) {
    font-size: 24px;
  }
  @media (max-width: 767px) {
    font-size: 15px;
  }
}
.task-info {
  background-color: rgb(245, 246, 248);
  border-radius: 12px;
  .count {
    width: 25px;
    height: 58px;
    font-size: 38px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 0.54;
    letter-spacing: normal;
    text-align: left;
    color: #4f78e2;
    font-family: "SF-Pro-Text";
  }
  .task-input {
    font-family: "SF-Pro-Text";
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.67;
    letter-spacing: -0.38px;
  }
}
.clear {
  width: 25px;
  height: 25px;
  border-radius: 5px;
  background-color: rgb(253, 218, 213);
  cursor: pointer;
  position: relative;
  top: -28px;
  left: 3px;
  &:after {
    content: "";
    height: 11px;
    border-left: 2px solid #fc452d;
    position: absolute;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    left: 12px;
    top: 7px;
  }
  &:before {
    content: "";
    height: 11px;
    border-left: 2px solid #fc452d;
    position: absolute;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    left: 12px;
    top: 7px;
  }
}
.count-task-body {
  padding: 0px !important;
  .w-20 {
    width: 20% !important;
  }
  .w-100 {
    width: 100% !important;
  }
}
.time-selector {
  .clock-hour {
    border: 1px solid #becad6;
    border-radius: 3px;
    position: relative;
    select {
      background: white !important;
      color: black !important;
      text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4) !important;
      background-repeat: no-repeat;
      -webkit-appearance: none;
      -moz-appearance: none;
      position: relative;
      cursor: pointer;
    }
    .select-down {
      position: absolute;
      pointer-events: none;
      right: 10px;
      top: 5px;
      &__icon {
        width: 13px;
      }
    }
    .select-hours {
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
      margin-top: 6px;
      position: relative;
      @media screen and (min-width: 1366px) and (max-width: 1920px) {
        margin-top: 4px;
      }
    }
    .clock {
      padding: 10px;
      background-color: #f5f6f8;
      border-top-left-radius: 3px;
      border-bottom-left-radius: 3px;
      border-right: 1px solid #becad6;
      color: #becad6 !important;
    }
    .valid-hour {
      color: red;
    }
  }
  .label {
    font-size: 13px;
    font-weight: 500;
    font-family: "SF-Pro-Text";
    color: #212529;
  }
  .total-hour {
    border-radius: 8px;
    border: solid 1px #e5eef2;
    background-color: #f5f6f8;
  }
}
.overlay-add-new {
  position: relative;
  cursor: pointer;
  .add-new-task {
    border-radius: 18px;
    text-align: center;
    font-family: "SF-Pro-Text";
    font-size: 22px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 0.54;
    letter-spacing: normal;
    color: #4f78e2;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    @media screen and (min-width: 768px) and (max-width: 1024px) {
      font-size: 19px;
    }
    @media (max-width: 767px) {
      font-size: 14px;
    }
    span {
      font-family: "SF-Pro-Text";
      font-weight: 600;
    }
  }
  .add-new-dots-border {
    width: 100%;
    @media (max-width: 767px) {
      top: 0;
    }
    img {
      width: 100%;
    }
  }
}
.full-w-filde {
  width: 100%;
  select {
    width: 100%;
    outline: none;
  }
}
.textarea-custom-e {
  resize: none;
  height: 270px !important;
  @media (max-width: 767px) {
    height: auto !important;
  }
}
.time-only-mobile {
  display: none;
}
@media (max-width: 767px) {
  .time-only-desktop {
    display: none;
  }
  .time-only-mobile {
    display: block;
  }
}

.report-field {
  width: 25%;
  @media (max-width: 767px) {
    width: 90%;
    margin: 7px auto;
  }
}
.report-field-label {
  width: auto;
  @media (max-width: 767px) {
    width: 90%;
    margin: 7px auto;
  }
}
.no-report {
  background-color: salmon;
  border: salmon;
  color: #fff;
  border-radius: 1px;
  font-family: "SF-Pro-Text";
  font-weight: 500;
  outline: none;
}
</style>
